module.exports = __webpack_public_path__ + "img/04_choice3.2c5b30af.png";